/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_oA_111_65(e) {
  let t = (0, ReactCompiler.c)(14),
    { previa: n } = e,
    r = n?.contrastes;
  if (!r) return null;
  let i = r.boton < 4.5,
    a = `flex flex-col gap-2 rounded-2xl border p-3 ${i ? `border-(--warning-border) bg-(--warning-bg)` : `border-(--border) bg-(--panel)`}`,
    o = n.tokens?.[`--accent-fg`],
    s;
  t[0] !== n.colorAcento || t[1] !== o
    ? ((s = (
        <span
          className={`rounded-full px-3 py-1.5 text-sm font-medium`}
          style={{
            background: n.colorAcento,
            color: o,
          }}
          children={`Así se ve un botón`}
        />
      )),
      (t[0] = n.colorAcento),
      (t[1] = o),
      (t[2] = s))
    : (s = t[2]);
  let c = n.tokens?.[`--accent-texto`],
    l;
  t[3] === c
    ? (l = t[4])
    : ((l = (
        <span
          className={`text-sm font-medium`}
          style={{
            color: c,
          }}
          children={`Y así un enlace`}
        />
      )),
      (t[3] = c),
      (t[4] = l));
  let u;
  t[5] !== s || t[6] !== l
    ? ((u = (
        <div
          className={`flex flex-wrap items-center gap-2`}
          children={[s, l]}
        />
      )),
      (t[5] = s),
      (t[6] = l),
      (t[7] = u))
    : (u = t[7]);
  let d;
  t[8] === i
    ? (d = t[9])
    : ((d = i && (
        <p
          className={`text-xs text-(--text-h)`}
          children={`El texto del botón cuesta leerlo sobre ese color. Probá uno más oscuro o más claro.`}
        />
      )),
      (t[8] = i),
      (t[9] = d));
  let f;
  return (
    t[10] !== a || t[11] !== u || t[12] !== d
      ? ((f = <div className={a} children={[u, d]} />),
        (t[10] = a),
        (t[11] = u),
        (t[12] = d),
        (t[13] = f))
      : (f = t[13]),
    f
  );
}
